import {DateTime} from 'luxon';
import {AACUser} from "./AAC_User.model";

export class AACBusinessUnit
{
    id: number;
    businessUnit: number;
    businessUnitName: string;
    businessUnitType: string;
    businessUnitDomain: string;
    clusterName: string;
    maxActiveUsers: number;
    serviceLevel: string;
    isActive: boolean;
    activationDate: string;
    registrationDate: string;
    trialDays: number;
    billingId: string;
    subscription: AACSubscription;
    registeredUsers: AACUser[] = [];

    constructor(aacBUData?: any,aacUserData?: any)
    {
        if (aacBUData instanceof AACUser) {
            this.id = aacBUData.aacBusinessUnitId;
            this.businessUnit = Number(aacBUData.aacBusinessUnit);
            this.businessUnitName = aacBUData.aacBusinessUnitName;
            this.businessUnitType = aacBUData.aacBusinessUnitType;
            this.businessUnitDomain = aacBUData.aacBusinessUnitDomain;
            this.clusterName = aacBUData.aacClusterName;
            this.maxActiveUsers = aacBUData.aacBusinessUnitMaxActiveUsers;
            this.serviceLevel = aacBUData.aacServiceLevel;
            this.isActive = aacBUData.aacBusinessUnitIsActive;
            this.activationDate = aacBUData.aacBusinessUnitActivationDate;
            this.registrationDate = aacBUData.aacBusinessUnitRegistrationDate;
            this.trialDays = aacBUData.aacBusinessUnitTrialDays;
            this.billingId = aacBUData.aacBillingId;
        }
        else if (aacBUData){
            this.id = aacBUData.id;
            this.businessUnit = aacBUData.businessUnit;
            this.businessUnitName = aacBUData.businessUnitName;
            this.businessUnitType = aacBUData.businessUnitType;
            this.businessUnitDomain = aacBUData.businessUnitDomain;
            this.clusterName = aacBUData.clusterName;
            this.maxActiveUsers = aacBUData.maxActiveUsers;
            this.serviceLevel = aacBUData.serviceLevel;
            this.isActive = aacBUData.isActive === 'Y';
            this.activationDate = aacBUData.activationDate;
            this.registrationDate = aacBUData.registrationDate;
            this.trialDays = aacBUData.trialDays;
            this.billingId = aacBUData.billingId;
            this.subscription = new AACSubscription(aacBUData.subscription);
            if(aacUserData){
                aacUserData.forEach(user => { if(user?.id){const usr = new AACUser({success:true, registeredUser:user}); this.registeredUsers.push(usr);}})
            }
        }
    }

    getTrialDaysRemaining(): string {
        let days = '';

        if ((this.serviceLevel === 'TRIAL' || this.serviceLevel === 'PRE-TRIAL') && this.trialDays && this.registrationDate){
            const currentDate = DateTime.local();
            const registrationDate = DateTime.fromSQL(this.registrationDate);
            const dateTime1 = DateTime.fromObject({ year: currentDate.year, month: currentDate.month, day: currentDate.day });
            const dateTime2 = DateTime.fromObject({ year: registrationDate.year, month: registrationDate.month, day: registrationDate.day });
            const diff = dateTime1.diff(dateTime2, ["days"])
            const trialDaysUsed = Math.ceil(diff.days);
            days = (this.trialDays - trialDaysUsed) < 0 ? '0' : String(this.trialDays - trialDaysUsed);
        }
        return days;
    }

    getSubscriptionDaysRemaining(): string {
        let days = '';

        if (this.serviceLevel === 'SUBSCRIPTION' && this.subscription?.subscriptionId){
            const currentDate = DateTime.local();
            //const expireDate = DateTime.fromSQL(this.subscription?.expirationDate);
            const expireDate = DateTime.fromJSDate(this.subscription?.expirationDate);
            const dateTime1 = DateTime.fromObject({ year: currentDate.year, month: currentDate.month, day: currentDate.day });
            const dateTime2 = DateTime.fromObject({ year: expireDate.year, month: expireDate.month, day: expireDate.day });
            const diff = dateTime2.diff(dateTime1, ["days"])
            const subDaysRemaining = Math.ceil(diff.days);
            days = subDaysRemaining < 0 ? '0' : String(subDaysRemaining);
        }
        return days;
    }

    getRegistrationDateDisplay(): string {
        let regDate = '';

        if (this.registrationDate){
            regDate = DateTime.fromSQL(this.registrationDate).toFormat('MM-dd-yyyy');
        }
        return regDate;
    }

    getIsAccountActive(): boolean {
        return (this.serviceLevel === 'TRIAL' || this.serviceLevel === 'PRE-TRIAL') ? this.getTrialDaysRemaining() !== '0' : this.serviceLevel === 'SUBSCRIPTION' && this.subscription?.subscriptionId ? this.getSubscriptionDaysRemaining() !== '0' : this.isActive;
    }
}

export class AACSubscription
{
    id: number;
    subscriptionId: string;
    subscriptionType: string;
    description: string;
    isActive: boolean;
    expirationDate: Date;
    renewalDate: Date;

    constructor(aacSubscriptionData?: any)
    {
        if (aacSubscriptionData){
            this.id = aacSubscriptionData.id;
            this.subscriptionId = aacSubscriptionData.subscriptionId;
            this.description = aacSubscriptionData.description;
            this.subscriptionType = aacSubscriptionData.subscriptionType;
            this.isActive = aacSubscriptionData.isActive === 'Y';
            if(aacSubscriptionData.expirationDate){
                const sqlDate = DateTime.fromSQL(aacSubscriptionData.expirationDate);
                this.expirationDate = new Date(sqlDate.toISO());
            }
            if(aacSubscriptionData.renewalDate){
                const sqlDate = DateTime.fromSQL(aacSubscriptionData.renewalDate);
                this.renewalDate = new Date(sqlDate.toISO());
            }
        }
    }

    getRenewalDateDisplay(): string {
        let regDate = '';

        if (this.renewalDate){
            regDate = DateTime.fromJSDate(this.renewalDate).toFormat('MM-dd-yyyy');
        }
        return regDate;
    }

    getExpireDateDisplay(): string {
        let regDate = '';

        if (this.expirationDate){
            regDate = DateTime.fromJSDate(this.expirationDate).toFormat('MM-dd-yyyy');
        }
        return regDate;
    }
}
